import React, { useState } from "react";
import { SupportDistrictApi } from "../../../../../../../../services/support/types";
import DistrictListTable from "./components/DistrictListTable";
import SearchDistrictsForm from "./components/SearchDistrictsForm";

const SupportActionsDistrictsPage = () => {
	const [data, setData] = useState<SupportDistrictApi[]>([]);
	const [dataLoading, setDataLoading] = useState(false);

	return (
		<div>
			<SearchDistrictsForm
				setData={setData}
				setDataLoading={setDataLoading}
				data={data}
				dataLoading={dataLoading}
			/>
			<DistrictListTable data={data} dataLoading={dataLoading} />
		</div>
	);
};

export default SupportActionsDistrictsPage;
